import { render, staticRenderFns } from "./VehicleAvailability.vue?vue&type=template&id=482a80c9&scoped=true&"
import script from "./VehicleAvailability.vue?vue&type=script&lang=js&"
export * from "./VehicleAvailability.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAvailability.vue?vue&type=style&index=0&id=482a80c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a80c9",
  null
  
)

export default component.exports